import React from "react";
import { connect } from "react-redux";
import { ActionPromises } from "./../../state/actionPromises"
import RequestPasswordResetForm from "./../../../shared/components/authentication/requestPasswordResetForm";
import { RoutesInvoker } from "../../routesInvoker";

interface DispatchProps {
  forgotPassword: (r: IForgottenPasswordRequest) => Promise<any>;
}

const mapDispatchToProps = (dispatch): DispatchProps =>  {
  return {
    forgotPassword: (forgotPasswordRequest: IForgottenPasswordRequest) => { return dispatch(ActionPromises.forgotPassword(forgotPasswordRequest)) }
  }
}

/** Thin wrapper around ForgottenPaswordForm */
class RequestPasswordReset extends React.Component<DispatchProps, any> {
  render() {
    return <RequestPasswordResetForm submit={this.props.forgotPassword} routeToLogin={RoutesInvoker.login()} />
  }
}

export default connect(null, mapDispatchToProps)(RequestPasswordReset);
